module.exports = __webpack_public_path__ + "static/girlBalloon-8319c5bdd992eb1ff15956273e38ab8c.jpg";